import script from "./register.vue?vue&type=script&lang=ts&setup=true"
export * from "./register.vue?vue&type=script&lang=ts&setup=true"

import "./register.vue?vue&type=style&index=0&id=46b2f56a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46b2f56a"]])

export default __exports__